module.exports = __webpack_public_path__ + "static/media/loved_icon_blue.79cc6458.svg";